<template>
  <div v-if="showPrintableContent" class="print-confirmation">
    <v-btn @click="printAppointmentConfirmation" class="quote__print-button" elevation="0" color="primary">
      <v-icon left>mdi-printer</v-icon>
      {{ $t('quote.label.print') }}
    </v-btn>


    <h3 class="mb-6">
      {{ $t('appointment.confirmAppointment.confirmationData') }}
    </h3>

    <v-row>
      <v-col>
        <h6 class="text-uppercase">
          {{ $t('appointment.confirmAppointment.form.confirmAppointment') }}
        </h6>
        <p>{{ $t(`boolean.${confirmed}`) }}</p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase">
          {{ $t('appointment.confirmAppointment.form.keysNeedsAuthorization') }}
        </h6>
        <p>{{ $t(`boolean.${keysNeedsAuthorization}`) }}</p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase">
          {{ $t('appointment.confirmAppointment.form.attendingToAppointment') }}
        </h6>
        <p>{{ $t(`boolean.${attendingToAppointment}`) }}</p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase">
          {{ $t('appointment.confirmAppointment.form.answeredAt') }}
        </h6>
        <p>
          {{ answeredAt != null
                ? formatDate(answeredAt)
                : '---' }}
        </p>
      </v-col>
    </v-row>

    <div v-if="comment">
      <h6 class="text-uppercase">
        {{ $t('appointment.confirmAppointment.form.observation') }}
      </h6>
      <p>{{ comment }}</p>
    </div>

    <div v-if="signature">
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <img
            :src="confirmationSignature"
            class="signature-image"
          >
          <div class="signature-line"></div>
          <h6 class="text-uppercase">
            {{ $t('appointment.confirmAppointment.form.signature') }}
          </h6>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { catalogDate } from '@/util/catalog'
import moment from 'moment-timezone'

export default {
  name: 'ConfirmaAppointmentPrint',

  props: {
    status: {
      type: String,
      required: false,
    },

    confirmationData: {
      type: Object,
      required: false,
    },

    confirmationSignature: {
      type: String,
      required: false,
    },

    isAdminOrPartner: {
      type: Boolean,
      default: false,
    },

    timezone: {
      type: String,
      required: false,
    }
  },

  data() {
    return {
      formatDate: catalogDate,
    }
  },

  computed: {
    confirmed() {
      return this.confirmationData?.confirmed
    },

    keysNeedsAuthorization() {
      return this.confirmationData?.keys_needs_authorization ?? false
    },

    attendingToAppointment() {
      return this.confirmationData?.attending_to_appointment
    },

    answeredAt() {
      return moment(this.confirmationData?.answered_at).tz(this.timezone)
    },

    answered() {
      return this.confirmationData?.answered
    },

    comment() {
      return this.confirmationData?.comment
    },

    signature() {
      return this.confirmationSignature
    },

    showPrintableContent() {
      if (!this.status) return false
      if (!this.confirmationData) return false
      if (!this.answered) return false
      return this.isAdminOrPartner
    }
  },

  methods: {
    printAppointmentConfirmation() {
      window.print()
    },
  },
}
</script>

<style scoped>
.print-confirmation {
  margin: 30px 0;
}

.signature-image {
  width: 200px;
  height: auto;
  margin: auto;
}

.signature-line {
  width: 200px;
  border-top: 1px solid #000;
  margin: 5px auto 10px;
}
</style>
